/* @flow */
import actionTypes from '../actions/actionsFactory/types';

export const INITIAL_STATE = {
  alreadyTradeBtc: '',
  hasGainPromoCode: '',
  activityStartTime: '',
  activityEndTime: '',
  promoCodeEventId: 0,
};


export const reducer = (state: Object, action: Object) => {
  switch (action.type) {
    case actionTypes.GET_HAS_TRADE_BTC_SUCCESS:
      return { ...state, alreadyTradeBtc: action.data.tradeNumber };
    case actionTypes.GET_PROMOCODE_SUCCESS:
      return { ...state, hasGainPromoCode: action.data[0] };
    case actionTypes.GET_PROMOCODE_EVENT_INFO_SUCCESS:
      return {
        ...state, activityStartTime: action.data[0].startDate, activityEndTime: action.data[0].endDate, promoCodeEventId: action.data[0].id,
      };
    case actionTypes.FORM_PROMOCODE_SUCCESS:
      return { ...state, hasGainPromoCode: action.data };
    default:
      return state;
  }
};

export default {};
